<template>
  <HomeSearchBar
    class="jl-search"
    :filter.sync="localFilter"
    :course-options="courseOptions"
    :location-options="locationOptions"
    variant="hero"
    id-prefix="jl-search"
    submit-label="Search"
    show-reset
    @search="$emit('search', $event)"
    @reset="$emit('reset')"
  />
</template>

<script>
import HomeSearchBar from '@/components/home/HomeSearchBar.vue';

export default {
  name: 'JobsListSearch',
  components: { HomeSearchBar },
  props: {
    filter: { type: Object, required: true },
    courseOptions: { type: Array, default: () => [] },
    locationOptions: { type: Array, default: () => [] },
  },
  computed: {
    localFilter: {
      get() { return this.filter; },
      set(val) { this.$emit('update:filter', val); },
    },
  },
};
</script>
